import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {UserListItem} from '../invitation.type';
import {cn, goTo, toPriceStr} from '@/utils';
import {ReactComponent as QuestionIcon} from '@/assets/icons/invitation/question.svg';
import {ProgressBar} from 'antd-mobile';
import {ReactComponent as UnreachIcon} from '@/assets/icons/invitation/unreach.svg';
import {ReactComponent as ReachedIcon} from '@/assets/icons/invitation/reached.svg';
import {ReactComponent as PersonIcon} from '@/assets/icons/invitation/person.svg';
export interface InvitationBigProgressProps {
  userList?: UserListItem[];
}

const InvitationBigProgress: React.FC<InvitationBigProgressProps> = ({
  userList,
}) => {
  const {t} = useTranslation();

  const listLength = useMemo(() => {
    if (!userList) {
      return 0;
    }
    return Math.min(userList.length, 6);
  }, [userList]);
  const nextUserItem = useMemo(() => {
    if (!userList) {
      return;
    }
    const resultItem = userList
      .slice(0, listLength)
      .find(item => item.invitedNumber < item.inviteNumber);
    return resultItem || userList[listLength - 1];
  }, [userList, listLength]);
  const reachedCount = useMemo(() => {
    if (!userList) {
      return 0;
    }
    return userList
      .slice(0, listLength)
      .filter(item => item.invitedNumber >= item.inviteNumber).length;
  }, [userList, listLength]);
  const showList = useMemo(() => {
    if (!userList) {
      return [];
    }
    return userList.slice(0, listLength);
  }, [userList, listLength]);
  return (
    <div className="mt-3 flex flex-col border border-[#D0BD88] rounded-lg pb-3">
      <div className="flex flex-row items-start justify-between py-2 px-3">
        <div className="flex flex-col gap-1">
          <span className="text-[#C9B65B] font-bold text-xs">
            {t('invitation.home.inviteGet', {
              count:
                (nextUserItem?.inviteNumber || 0) -
                (nextUserItem?.invitedNumber || 0),
            })}
          </span>
          <span
            className="font-bold text-[1.125rem] bg-clip-text text-transparent"
            style={{
              backgroundImage:
                'linear-gradient(to bottom, #F7C673 0%, #FFF7D9 50%, #F0BF32 100%)',
            }}>
            {toPriceStr(nextUserItem?.bonusAmount || 0, {fixed: 0})}
          </span>
        </div>
        <div
          onClick={() => {
            goTo('InvitationRule');
          }}>
          <QuestionIcon className="size-4" />
        </div>
      </div>
      <div className="px-7 flex flex-col gap-1">
        {/* 金币部分 */}
        <div className="relative h-9">
          {showList.map((item, i) => {
            return (
              <div
                key={i}
                className="flex flex-col items-center w-[3.375rem] absolute top-1/2 -translate-y-1/2"
                style={{
                  left: `calc(${i * (100 / (listLength - 1))}% - 1.6875rem)`,
                }}>
                <div
                  className="size-6 bg-full bg-no-repeat"
                  style={{
                    backgroundImage: `url(${require('@/assets/icons/invitation/money.webp')})`,
                  }}
                />
                <span className="leading-[normal] text-[#C9B65B] text-[.625rem]">
                  {toPriceStr(item.bonusAmount || 0, {fixed: 0})}
                </span>
              </div>
            );
          })}
        </div>
        {/* 进度部分 */}
        <div className="relative">
          <ProgressBar
            percent={
              reachedCount > 0
                ? ((reachedCount - 1) / (listLength - 1)) * 100
                : 0
            }
            rounded
            className="[--track-width:0.5rem] [--fill-color:#AC8E00] [--track-color:rgba(255,255,255,0.8)]"
          />
          {showList.map((item, i) => {
            return item.invitedNumber < item.inviteNumber ? (
              <UnreachIcon
                key={i}
                className="size-3 absolute top-1/2 -translate-y-1/2"
                style={{
                  left: `calc(${i * (100 / (listLength - 1))}% - 0.375rem)`,
                }}
              />
            ) : (
              <ReachedIcon
                key={i}
                className="size-3 absolute top-1/2 -translate-y-1/2"
                style={{
                  left: `calc(${i * (100 / (listLength - 1))}% - 0.375rem)`,
                }}
              />
            );
          })}
        </div>
        {/* 用户部分 */}
        <div className="relative h-3">
          {showList.map((item, i) => {
            return (
              <div
                key={i}
                className="flex flex-row items-center justify-center w-[3.375rem] absolute top-1/2 -translate-y-1/2 gap-0.5"
                style={{
                  left: `calc(${i * (100 / (listLength - 1))}% - 1.6875rem)`,
                }}>
                <PersonIcon
                  className={cn(
                    'size-3',
                    item.invitedNumber < item.inviteNumber && 'opacity-60',
                  )}
                />
                <span className="text-white/60 text-[0.625rem]">
                  {item.invitedNumber < item.inviteNumber ? (
                    item.invitedNumber
                  ) : (
                    <span className="text-white">{item.invitedNumber}</span>
                  )}
                  /{item.inviteNumber}
                </span>
              </div>
            );
          })}
        </div>
        <div />
      </div>
    </div>
  );
};

export default InvitationBigProgress;
